export type Signature = Uint8Array;
